import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";

import type { PacksList } from "@/types";
import type { GlobalState } from "../../store";

const initialState: PacksList[] = [];

export const packsState = createSlice({
  name: "packs",
  initialState,
  reducers: {
    set: (state, action: PayloadAction<PacksList[]>) =>
      (state = action.payload),
    updateOpenedPackBucket: (
      state,
      action: PayloadAction<{
        packId: number;
        bucketId: number;
        opened: boolean;
        disabled: boolean;
        max?: number;
      }>
    ) => {
      return state.map((itm) => {
        if (itm.id === action.payload.packId) {
          return {
            ...itm,
            buckets: itm.buckets.map((bucket) => {
              if (bucket.id === action.payload.bucketId) {
                return {
                  ...bucket,
                  opened: action.payload.opened,
                  disabled: action.payload.disabled,
                  max: action.payload.max ?? bucket.max,
                };
              } else {
                return { ...bucket };
              }
            }),
          };
        } else {
          return { ...itm };
        }
      });
    },
    setPackBucketMaxCountReached: (
      state,
      action: PayloadAction<{
        bucketId: number;
        isMaxCountReached: boolean;
        packId: number;
      }>
    ) => {
      return state.map((itm) => {
        if (itm.id === action.payload.packId) {
          return {
            ...itm,
            buckets: itm.buckets.map((bucket) => {
              if (bucket.id === action.payload.bucketId) {
                return {
                  ...bucket,
                  isMaxCountReached: action.payload.isMaxCountReached,
                };
              } else {
                return { ...bucket };
              }
            }),
          };
        } else {
          return { ...itm };
        }
      });
    },
    updatePackBucketMax: (
      state,
      action: PayloadAction<{ packId: number; max: number; bucketId: number }>
    ) => {
      return state.map((itm) => {
        if (itm.id === action.payload.packId) {
          return {
            ...itm,
            buckets: itm.buckets.map((bucket) => {
              if (bucket.id === action.payload.bucketId)
                return {
                  ...bucket,
                  max: action.payload.max,
                };
              else return { ...bucket };
            }),
          };
        } else {
          return { ...itm };
        }
      });
    },
  },
});

const selector = (s: GlobalState) => s.data.purchaseSeats.packs;
export const selectPacks = createSelector(selector, (s) => s);
export const selectSelectedPack = createSelector(selector, (s) =>
  s.find((pack) => pack.selected)
);

export const {
  set,
  updatePackBucketMax,
  updateOpenedPackBucket,
  setPackBucketMaxCountReached,
} = packsState.actions;
export default packsState.reducer;
